/**
 * Which clients carry the session as a Bearer token instead of a cookie.
 *
 * Two do: the Capacitor app, whose webview shares no cookies with the backend,
 * and the Office add-in, which Outlook frames on its own site where our cookie
 * is third-party (KAN-1766). Both sign in through the same handoff (a one-time
 * code from the login, exchanged for the session id) and renew silently from
 * the stored refresh token. Everything on the request path that used to ask
 * "is this the app?" for that reason asks this instead; what is really about
 * the app (keyboard, app lock, file viewer, store rules) keeps asking
 * `isNativeShell`.
 */
import { isOfficePane } from '@/lib/office/host';

import { isNativeShell } from './platform';

export function usesBearerSession(): boolean {
  return isNativeShell() || isOfficePane();
}
